import styled from "styled-components";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const StyledBack = styled.button`
  min-width: 43px;
  width: 43px;
  height: 43px;
  border-radius: 50%;
  border: 1px solid ${GrayColors["G-1-5"]};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 1px;
  color: ${SolutionColorVariables.sc1};
  transition: 200ms border-color ease-in;

  &:hover {
    color: ${SolutionColorVariables.sc3};
    border-color: ${GrayColors["G-3"]};
    transition: 200ms border-color ease-in;
  }
`;
